import { createAuthClient } from 'better-auth/react'
import { passkeyClient } from '@better-auth/passkey/client'

export const authClient = createAuthClient({
  baseURL: typeof window !== 'undefined' ? window.location.origin : '',
  basePath: '/api/auth',
  plugins: [passkeyClient()],
})

export const { 
  signIn, 
  signOut, 
  signUp, 
  useSession,
  getSession,
  passkey,
} = authClient
